export enum SyntaxCheckError {
  Token = ("Unexpected token"),               //意外的标记
  ILLEGAL = ("Unexpected token ILLEGAL"),     //非法的标识符
  EndOfInpur = ("Unexpected end of input")    //意外的输入结束
}

export enum TranslateSyntaxCheckError {
  Token = ("意外的记号"),
  ILLEGAL = ("非法的标识符"),
  EndOfInpur = ("意外的结束标识")
}